import { ChevronDownIcon } from 'lucide-react'

import type { MissionCategory } from '../lib/missionCategories'

import { cn } from '@/shared/lib/utils'

interface MissionSectionHeaderProps {
  category: MissionCategory
  count: number
  // Só a seção do Passe Mensal recolhe hoje (o card pede só ela). As demais
  // seguem como rótulo estático — omitir estas duas props mantém o
  // comportamento anterior, inclusive a ausência de role de botão.
  expanded?: boolean
  onToggle?: () => void
  contentId?: string
}

// Dot color = the matching chip's active-state color token (design.md
// Decision 7) — same MissionCategory object drives both.
export function MissionSectionHeader({
  category,
  count,
  expanded,
  onToggle,
  contentId
}: MissionSectionHeaderProps) {
  const label = (
    <>
      <span
        className="size-2.5 shrink-0 rounded-[3px]"
        style={{ backgroundColor: category.colorToken }}
        aria-hidden
      />
      <span className="font-sans text-sm font-bold text-[#221B4B]">
        {category.label}
      </span>
      <span className="font-sans text-sm text-gray-400">{count}</span>
    </>
  )

  if (!onToggle) {
    return <div className="flex items-center gap-2 px-1">{label}</div>
  }

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={expanded}
      aria-controls={contentId}
      className="flex w-full items-center gap-2 rounded-lg px-1 py-0.5 text-left transition-colors hover:bg-black/[0.03]"
    >
      {label}
      <ChevronDownIcon
        className={cn(
          'ml-auto size-4 shrink-0 text-gray-400 transition-transform',
          expanded && 'rotate-180'
        )}
        aria-hidden
      />
    </button>
  )
}
